import { RegisterFlowCalculatorBase, FlowData } from '@common/services/register-flow-calculator.service.base';
import { Flow } from '@common/model/data-layer';
import { Injectable } from '@angular/core';
import { RegisterFlowActionTracker } from './register-flow-action-tracker.service';


@Injectable()
export class RegisterFlowCalculator extends RegisterFlowCalculatorBase {

    constructor(private actionTracker: RegisterFlowActionTracker) {
        super();
    }

    flow(data: FlowData): Flow {


        if (this.actionTracker.isAlreadyEmited('startedFromRegularFlow')) {
            data.startedWithStep = data.startedWithStep ? data.startedWithStep : 'person';
        }
        else {
            data.startedWithStep = data.enteredFlowFromLink ? 'link' : data.startedWithStep ? data.startedWithStep : 'person';
        }

        if (data.previousStep === 'person'
            && data.goToStep === 'product'
            && data.registration?.status === 'Created'
            && data.startedWithStep !== 'link') {
            this.actionTracker.addEmition('startedFromRegularFlow');
        }

        if (data.goToStep === 'product'
            && data.registration?.status === 'Created'
            && this.actionTracker.isAlreadyEmited('startedFromRegularFlow')) {

            if (!this.actionTracker.isAlreadyEmited('personCompleted')) {
                this.actionTracker.addEmition('personCompleted');
                return { start: 'person', action: 'personCompleted' };
            }
        }

        return super.flow(data);
    }
}
